import Axios, { Method } from 'axios';
import _store from '@/store';
import Env from '@/services/env.service';

export default function(
  path: string,
  useAuth: boolean = true,
  customHeaders: any = {},
  responseType?: string,
  rootUrl?: string,
  useLocalPath?: boolean
) {
  rootUrl = useLocalPath ? '' : (rootUrl || Env.get('VUE_APP_API_ROOT'));
  const token = useAuth ? _store.state.auth.authToken : '';
  let headers: any = useAuth ? { Authorization: 'Bearer ' + token } : {};
  headers = {...headers, ...customHeaders};
  if (Env.get('VUE_APP_NAMESPACE')) {
    headers['namespace'] = Env.get('VUE_APP_NAMESPACE');
  }
  const method: Method = 'GET';

  const req: any = { method, headers,withCredentials : true };

  if (responseType) {
    req.responseType = responseType;
  }

  if (/^\/\//.test(path) || /file:/.test(path)) throw new Error("Unsafe path for axios request");
  return Axios(rootUrl + path, req)
    .then((res: any) => {
      return res;
    }, (err: any) => {
      // tslint:disable-next-line:no-console
      console.error(err);
      throw err;
    });
}
